import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Output, Input, ViewChild, NgModule } from '@angular/core';
import { pluck, map, takeUntil, take } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import * as i6 from '@ngrx/store';
import { select } from '@ngrx/store';
import moment from 'moment';
import { getDataSourceCountryList, SetDataSourceCountryList } from 'visa-store';
import * as i3 from 'reference-library';
import * as i4 from 'cache-country-list';
import * as i5 from 'ngx-toastr';
import * as i7 from 'primeng/dropdown';
import * as i8 from '@angular/common';
import * as i9 from 'primeng/calendar';
import * as i10 from 'primeng/table';
import * as i11 from 'primeng/api';
import * as i12 from '@progress/kendo-angular-editor';
import { EditorModule } from '@progress/kendo-angular-editor';
import * as i13 from '@progress/kendo-angular-toolbar';
import * as i14 from 'editor-library';
import { EditorLibraryModule } from 'editor-library';
import * as i15 from 'primeng/multiselect';
import * as i16 from 'primeng/tooltip';
import * as i17 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';

class LibAddNewEmployeeService {
    constructor(http) {
        this.http = http;
    }
    getDataSourceList(dataSourceType) {
        var encryptedText = this.toEncrypt(dataSourceType);
        return this.http.get(`/vd/dataSource/${dataSourceType}/elements`).pipe(pluck("data"), map((data) => {
            return data;
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
    addEmployee(payload) {
        return this.http.post('/vd/fb/employeeBulkEdit/save', payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
}
LibAddNewEmployeeService.ɵfac = function LibAddNewEmployeeService_Factory(t) { return new (t || LibAddNewEmployeeService)(i0.ɵɵinject(i1.HttpClient)); };
LibAddNewEmployeeService.ɵprov = i0.ɵɵdefineInjectable({ token: LibAddNewEmployeeService, factory: LibAddNewEmployeeService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibAddNewEmployeeService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["commonkendoeditorupload"];
function LibAddNewEmployeeComponent_span_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " First Name is Required ");
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_span_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " Please enter a valid First Name ");
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_span_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " Last Name is Required ");
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_span_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " Please enter a valid Last Name ");
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_span_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " Email is required ");
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_span_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " Please enter a valid email address ");
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_option_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 96);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r22 = ctx.$implicit;
    i0.ɵɵproperty("value", data_r22.phoneCode);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", data_r22.countryName, " - ", data_r22.phoneCode, " ");
} }
function LibAddNewEmployeeComponent_span_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " Mobile Number is Required ");
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_span_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " Please enter a valid phone number ");
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_span_63_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " DOJ is Required ");
    i0.ɵɵelementEnd();
} }
const _c1 = function () { return { "width": "100%" }; };
function LibAddNewEmployeeComponent_div_99_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵelementStart(1, "label", 6);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 98);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(3, _c1));
    i0.ɵɵproperty("options", ctx_r11.listStates);
} }
function LibAddNewEmployeeComponent_div_100_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵelementStart(1, "label", 6);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 99);
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_ng_template_112_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_ng_template_113_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 100);
    i0.ɵɵelementStart(8, "div", 101);
    i0.ɵɵelementStart(9, "button", 102);
    i0.ɵɵlistener("click", function LibAddNewEmployeeComponent_ng_template_113_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r26); const rowIndex_r24 = ctx.rowIndex; const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.onEdit(rowIndex_r24); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 103);
    i0.ɵɵlistener("click", function LibAddNewEmployeeComponent_ng_template_113_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r26); const rowIndex_r24 = ctx.rowIndex; const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.onDelete(rowIndex_r24); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r23 = ctx.$implicit;
    const ctx_r14 = i0.ɵɵnextContext();
    let tmp_0_0 = null;
    let tmp_1_0 = null;
    let tmp_2_0 = null;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_0_0 = row_r23.get("country")) == null ? null : tmp_0_0.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_1_0 = row_r23.get("state")) == null ? null : tmp_1_0.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_2_0 = row_r23.get("city")) == null ? null : tmp_2_0.value);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r14.disableAddButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r14.disableAddButton);
} }
function LibAddNewEmployeeComponent_ng_template_114_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 104);
    i0.ɵɵelementStart(2, "div", 105);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "No Data");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_span_135_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " Password is Required ");
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_span_142_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " Official EmailID is Required ");
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_span_143_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " Please enter a valid email address ");
    i0.ɵɵelementEnd();
} }
function LibAddNewEmployeeComponent_span_151_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 95);
    i0.ɵɵtext(1, " Role is Required ");
    i0.ɵɵelementEnd();
} }
const _c2 = function (a0) { return { "im-input-error": a0 }; };
const _c3 = function (a0) { return { "invalidBtn": a0 }; };
class LibAddNewEmployeeComponent {
    constructor(fb, libAddNewEmployeeService, referenceLibraryService, cdr, cc, toastr, store) {
        this.fb = fb;
        this.libAddNewEmployeeService = libAddNewEmployeeService;
        this.referenceLibraryService = referenceLibraryService;
        this.cdr = cdr;
        this.cc = cc;
        this.toastr = toastr;
        this.store = store;
        this.submitted = false;
        this.disableAddButton = false;
        this.observableSubscription$ = new Subject();
        this.formSaved = new EventEmitter();
        this.listStates = [];
        this.subscription = [];
    }
    ngOnChanges(changes) {
        if (changes['employeeDetails'] && changes['employeeDetails'].currentValue) {
            this.currentEmployeeDetails = changes['employeeDetails'].currentValue;
            if (!this.addNewEmployeeForm) {
                this.initializeForm();
            }
            this.getParsingDetails();
            this.addNewEmployeeForm.updateValueAndValidity();
            this.cdr.detectChanges();
        }
    }
    ngOnInit() {
        this.cc.getCountry().subscribe((data) => {
            this.DataArr = data;
            this.cdr.detectChanges();
        });
        this.getCountry();
        this.loadCompanyNames();
        this.loadTitles();
        this.loadEmployementTypes();
        this.loadNoticePeriod();
        this.loadDepartments();
        this.loadPositions();
        this.loadReportingManagers();
        this.loadWorkShifts();
        this.loadRoles();
        this.loadWelcomeKitList();
        this.loadAssetAllocationList();
        this.loadBackgroundCheckList();
    }
    initializeForm() {
        this.addNewEmployeeForm = this.fb.group({
            //hiringCompanyName: [''],
            title: [''],
            firstName: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+( [a-zA-Z]+)*$')]],
            lastName: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+( [a-zA-Z]+)*$')]],
            middleName: [''],
            personalEmailId: ['', [Validators.required, Validators.email]],
            phoneCode: [''],
            mobileNumber: ['', [Validators.required, Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\.0-9]*$')]],
            dojDate: ['', [Validators.required]],
            employementType: [''],
            noticePeriod: [''],
            department: [''],
            reportingManager: [''],
            jobPosition: [''],
            workShift: [''],
            gridEditorInputFields: this.fb.group({
                country: [''],
                state: [''],
                city: [''],
            }),
            gridEditorFields: this.fb.array([]),
            //gridEditorFields: this.fb.array([this.createGridEditorField()])
            compensation: [''],
            userName: [''],
            setPassword: ['', [Validators.required]],
            officialEmailId: ['', [Validators.required, Validators.email]],
            roles: ['', [Validators.required]],
            welcomeEmail: [''],
            welcomeKit: [''],
            initiateBackgroundCheck: [''],
            assetAllocation: [''],
            otherInstructions: ['']
        });
        this.empErrEditId = 'errorEditId' in sessionStorage ? sessionStorage.getItem('errorEditId') : null;
    }
    // createGridEditorField(): FormGroup {
    //   return this.fb.group({
    //     country: [''],
    //     state: [''],
    //     city: [''],
    //   });
    // }
    get gridEditorFields() {
        return this.addNewEmployeeForm.get('gridEditorFields');
    }
    get gridEditorInputFields() {
        return this.addNewEmployeeForm.get('gridEditorInputFields');
    }
    get isGridEditorFieldsEmpty() {
        var _a;
        return ((_a = this.gridEditorFields) === null || _a === void 0 ? void 0 : _a.length) === 0;
    }
    addGridEditorField() {
        var _a, _b, _c;
        const newRow = this.fb.group({
            country: (_a = this.gridEditorInputFields.get('country')) === null || _a === void 0 ? void 0 : _a.value,
            state: (_b = this.gridEditorInputFields.get('state')) === null || _b === void 0 ? void 0 : _b.value,
            city: (_c = this.gridEditorInputFields.get('city')) === null || _c === void 0 ? void 0 : _c.value,
        });
        this.gridEditorFields.push(newRow);
        this.gridEditorInputFields.reset();
    }
    // addGridEditorField() {
    //   const gridField = this.fb.group({
    //     country: ['', Validators.required],
    //     state: ['', Validators.required],
    //     city: ['', Validators.required],
    //   });
    //   this.gridEditorFields.push(gridField);
    // }
    // onCountryChange(event: any, index: number) {
    //   const countryId = event.value;
    //   const allStates = {
    //     1: [
    //       { id: 101, name: 'Alabama' },
    //       { id: 102, name: 'California' },
    //     ],
    //     2: [
    //       { id: 201, name: 'Ontario' },
    //       { id: 202, name: 'Quebec' },
    //     ],
    //   };
    //   this.listStates[index] = allStates[countryId] || [];
    // }
    onEdit(index) {
        const row = this.gridEditorFields.at(index);
        this.gridEditorInputFields.patchValue(row.value);
    }
    onDelete(index) {
        this.gridEditorFields.removeAt(index);
    }
    onReset() {
        this.gridEditorInputFields.reset();
        // if (this.editIndex !== null) {
        //   this.gridEditorFields.at(this.editIndex).reset();
        //   this.editIndex = null;
        // } else {
        //   this.gridEditorFields.clear();
        // }
    }
    commonkendoeditorimageuploaddialog() {
        this.commonkendoeditorupload.open();
    }
    loadCompanyNames() {
        this.libAddNewEmployeeService.getDataSourceList('COMPANYNAMEBYID').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
            this.companyNames = res;
        });
    }
    loadTitles() {
        this.libAddNewEmployeeService.getDataSourceList('FB_TITLE').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
            this.titles = res;
        });
    }
    loadEmployementTypes() {
        this.libAddNewEmployeeService.getDataSourceList('LMSEMPLOYMENTTYPE').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
            this.employementTypes = res;
        });
    }
    loadNoticePeriod() {
        this.libAddNewEmployeeService.getDataSourceList('FB_ONB_NOTICE_PERIOD').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
            this.noticePeriod = res;
        });
    }
    loadDepartments() {
        this.libAddNewEmployeeService.getDataSourceList('FBDEPARTMENTBYCOMPANYID').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
            this.departments = res;
        });
    }
    loadReportingManagers() {
        this.libAddNewEmployeeService.getDataSourceList('FB_ONB_REPORTING_MANAGER').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
            this.reportingManagers = res;
        });
    }
    loadPositions() {
        this.libAddNewEmployeeService.getDataSourceList('FB_ONB_JOB_POSITION').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
            this.positions = res;
        });
    }
    loadWorkShifts() {
        this.libAddNewEmployeeService.getDataSourceList('FBSHIFTBYFBDEPTID').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
            this.shifts = res;
        });
    }
    loadRoles() {
        this.libAddNewEmployeeService.getDataSourceList('ROLESBYCOMPANYID').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
            this.roles = res;
        });
    }
    loadWelcomeKitList() {
        this.libAddNewEmployeeService.getDataSourceList('FB_ONB_WELCOME_KIT_SETUP').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
            this.welcomeKitList = res;
        });
    }
    loadBackgroundCheckList() {
        this.libAddNewEmployeeService.getDataSourceList('FB_ONB_BG_CHECK_SETUP').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
            this.backgroundCheckList = res;
        });
    }
    loadAssetAllocationList() {
        this.libAddNewEmployeeService.getDataSourceList('FB_ONB_ASSET_ALLOC_SETUP').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
            this.assetAllocationList = res;
        });
    }
    handleCountryChange(evt) {
        let countryCode = evt === null || evt === void 0 ? void 0 : evt.value;
        if (countryCode) {
            this.referenceLibraryService.getStatesFromStore(countryCode)
                .pipe(take(1))
                .subscribe((states) => {
                if (states) {
                    this.listStates = states;
                }
                else {
                    this.referenceLibraryService.getStatesFromApi(countryCode)
                        .pipe(take(1))
                        .subscribe((data) => {
                        this.listStates = data || [];
                    });
                }
            });
        }
        else {
        }
    }
    getCountry() {
        this.store.pipe(select(getDataSourceCountryList))
            .pipe(take(1))
            .subscribe((data) => {
            if (data && data.length > 0) {
                this.countries = data;
            }
            else {
                this.referenceLibraryService.getDataSource('COUNTRY', '')
                    .pipe(take(1))
                    .subscribe((response) => {
                    this.countries = response || [];
                    this.store.dispatch(new SetDataSourceCountryList(response || null));
                });
            }
        });
    }
    getParsingDetails() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23;
        //this.addNewEmployeeForm.get('hiringCompanyName').setValue(this.currentEmployeeDetails?.companyObjId ? this.currentEmployeeDetails?.companyObjId.toString() : "");
        this.addNewEmployeeForm.get('title').setValue(((_a = this.currentEmployeeDetails) === null || _a === void 0 ? void 0 : _a.title) ? (_b = this.currentEmployeeDetails) === null || _b === void 0 ? void 0 : _b.title : "");
        this.addNewEmployeeForm.get('firstName').setValue(((_c = this.currentEmployeeDetails) === null || _c === void 0 ? void 0 : _c.firstName) ? (_d = this.currentEmployeeDetails) === null || _d === void 0 ? void 0 : _d.firstName : "");
        ;
        this.addNewEmployeeForm.get('lastName').setValue(((_e = this.currentEmployeeDetails) === null || _e === void 0 ? void 0 : _e.lastName) ? (_f = this.currentEmployeeDetails) === null || _f === void 0 ? void 0 : _f.lastName : "");
        this.addNewEmployeeForm.get('middleName').setValue(((_g = this.currentEmployeeDetails) === null || _g === void 0 ? void 0 : _g.middleName) ? (_h = this.currentEmployeeDetails) === null || _h === void 0 ? void 0 : _h.middleName : "");
        this.addNewEmployeeForm.get('personalEmailId').setValue(((_j = this.currentEmployeeDetails) === null || _j === void 0 ? void 0 : _j.personalEmail) ? (_k = this.currentEmployeeDetails) === null || _k === void 0 ? void 0 : _k.personalEmail : "");
        this.addNewEmployeeForm.get('phoneCode').setValue(((_l = this.currentEmployeeDetails) === null || _l === void 0 ? void 0 : _l.phoneCode) ? (_m = this.currentEmployeeDetails) === null || _m === void 0 ? void 0 : _m.phoneCode : "");
        this.addNewEmployeeForm.get('mobileNumber').setValue(((_o = this.currentEmployeeDetails) === null || _o === void 0 ? void 0 : _o.mobileNumber) ? (_p = this.currentEmployeeDetails) === null || _p === void 0 ? void 0 : _p.mobileNumber : "");
        this.addNewEmployeeForm.get('dojDate').setValue(((_q = this.currentEmployeeDetails) === null || _q === void 0 ? void 0 : _q.dateOfJoining) ? new Date(this.currentEmployeeDetails.dateOfJoining) : "");
        this.addNewEmployeeForm.get('employementType').setValue(((_r = this.currentEmployeeDetails) === null || _r === void 0 ? void 0 : _r.employeeType) ? (_s = this.currentEmployeeDetails) === null || _s === void 0 ? void 0 : _s.employeeType.toString() : "");
        this.addNewEmployeeForm.get('noticePeriod').setValue(((_t = this.currentEmployeeDetails) === null || _t === void 0 ? void 0 : _t.noticePeriodObjId) ? (_u = this.currentEmployeeDetails) === null || _u === void 0 ? void 0 : _u.noticePeriodObjId.toString() : "");
        this.addNewEmployeeForm.get('department').setValue(((_v = this.currentEmployeeDetails) === null || _v === void 0 ? void 0 : _v.departmentObjId) ? (_w = this.currentEmployeeDetails) === null || _w === void 0 ? void 0 : _w.departmentObjId.toString() : "");
        this.addNewEmployeeForm.get('reportingManager').setValue(((_x = this.currentEmployeeDetails) === null || _x === void 0 ? void 0 : _x.reportingManager) ? (_y = this.currentEmployeeDetails) === null || _y === void 0 ? void 0 : _y.reportingManager : "");
        this.addNewEmployeeForm.get('jobPosition').setValue(((_z = this.currentEmployeeDetails) === null || _z === void 0 ? void 0 : _z.designationId) ? (_0 = this.currentEmployeeDetails) === null || _0 === void 0 ? void 0 : _0.designationId.toString() : "");
        this.addNewEmployeeForm.get('workShift').setValue(((_1 = this.currentEmployeeDetails) === null || _1 === void 0 ? void 0 : _1.workShift) ? (_2 = this.currentEmployeeDetails) === null || _2 === void 0 ? void 0 : _2.workShift.toString() : "");
        if (((_3 = this.currentEmployeeDetails) === null || _3 === void 0 ? void 0 : _3.gridData) && Array.isArray(this.currentEmployeeDetails.gridData)) {
            this.bindGridEditorFields(this.currentEmployeeDetails.gridData);
        }
        this.addNewEmployeeForm.get('compensation').setValue(((_4 = this.currentEmployeeDetails) === null || _4 === void 0 ? void 0 : _4.compensation) ? (_5 = this.currentEmployeeDetails) === null || _5 === void 0 ? void 0 : _5.compensation : "");
        this.addNewEmployeeForm.get('userName').setValue(((_6 = this.currentEmployeeDetails) === null || _6 === void 0 ? void 0 : _6.userName) ? (_7 = this.currentEmployeeDetails) === null || _7 === void 0 ? void 0 : _7.userName : "");
        this.addNewEmployeeForm.get('setPassword').setValue(((_8 = this.currentEmployeeDetails) === null || _8 === void 0 ? void 0 : _8.password) ? (_9 = this.currentEmployeeDetails) === null || _9 === void 0 ? void 0 : _9.password : "");
        this.addNewEmployeeForm.get('officialEmailId').setValue(((_10 = this.currentEmployeeDetails) === null || _10 === void 0 ? void 0 : _10.officialEmail) ? (_11 = this.currentEmployeeDetails) === null || _11 === void 0 ? void 0 : _11.officialEmail : "");
        this.addNewEmployeeForm.get('roles').setValue(((_12 = this.currentEmployeeDetails) === null || _12 === void 0 ? void 0 : _12.roles) ? (_13 = this.currentEmployeeDetails) === null || _13 === void 0 ? void 0 : _13.roleId.toString() : "");
        this.addNewEmployeeForm.get('welcomeEmail').setValue(((_14 = this.currentEmployeeDetails) === null || _14 === void 0 ? void 0 : _14.welComeEmail) ? (_15 = this.currentEmployeeDetails) === null || _15 === void 0 ? void 0 : _15.welComeEmail : "");
        this.addNewEmployeeForm.get('welcomeKit').setValue(((_16 = this.currentEmployeeDetails) === null || _16 === void 0 ? void 0 : _16.welcomeKit) ? (_17 = this.currentEmployeeDetails) === null || _17 === void 0 ? void 0 : _17.welcomeKit : []);
        this.addNewEmployeeForm.get('initiateBackgroundCheck').setValue(((_18 = this.currentEmployeeDetails) === null || _18 === void 0 ? void 0 : _18.initiateBackgroundCheck) ? (_19 = this.currentEmployeeDetails) === null || _19 === void 0 ? void 0 : _19.initiateBackgroundCheck : []);
        this.addNewEmployeeForm.get('assetAllocation').setValue(((_20 = this.currentEmployeeDetails) === null || _20 === void 0 ? void 0 : _20.assetAllocation) ? (_21 = this.currentEmployeeDetails) === null || _21 === void 0 ? void 0 : _21.assetAllocation : []);
        this.addNewEmployeeForm.get('otherInstructions').setValue(((_22 = this.currentEmployeeDetails) === null || _22 === void 0 ? void 0 : _22.otherInstruction) ? (_23 = this.currentEmployeeDetails) === null || _23 === void 0 ? void 0 : _23.otherInstruction : "");
    }
    bindGridEditorFields(gridData) {
        while (this.gridEditorFields.length !== 0) {
            this.gridEditorFields.removeAt(0);
        }
        gridData.forEach((row) => {
            const newRow = this.fb.group({
                country: [row.country || ''],
                state: [row.state || ''],
                city: [row.city || ''],
            });
            this.gridEditorFields.push(newRow);
        });
    }
    saveEmployeeData() {
        const formValue = Object.assign(Object.assign({}, this.addNewEmployeeForm.value), { ddNewEmployeeForm: "SAVE_UPDATE_EMPLOYEE_MANUALLY", id: this.empErrEditId });
        if (formValue.dojDate) {
            formValue.dojDate = moment(formValue.dojDate).format('MM/DD/YYYY');
        }
        const payload = Object.assign({}, formValue);
        this.subscription[this.subscription.length] = this.libAddNewEmployeeService.addEmployee(payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.formSaved.emit();
            }
        });
    }
}
LibAddNewEmployeeComponent.ɵfac = function LibAddNewEmployeeComponent_Factory(t) { return new (t || LibAddNewEmployeeComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(LibAddNewEmployeeService), i0.ɵɵdirectiveInject(i3.ReferenceLibraryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i4.CacheCountryListService), i0.ɵɵdirectiveInject(i5.ToastrService), i0.ɵɵdirectiveInject(i6.Store)); };
LibAddNewEmployeeComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibAddNewEmployeeComponent, selectors: [["lib-add-new-employee"]], viewQuery: function LibAddNewEmployeeComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.commonkendoeditorupload = _t.first);
    } }, inputs: { employeeDetails: "employeeDetails" }, outputs: { formSaved: "formSaved" }, features: [i0.ɵɵNgOnChangesFeature], decls: 241, vars: 78, consts: [[1, "edit-emp-heading"], [3, "formGroup", "ngSubmit"], ["f", "ngForm"], [1, "detail-heading"], [1, "row", "mt-2", "row-margin"], [1, "col-4"], [1, "label-cls"], ["formControlName", "title", "optionLabel", "name", "optionValue", "code", "placeholder", "Select", 3, "options"], [1, "label-cls", "text-label", "details-label"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "firstName", "placeholder", "Enter your first Name", 1, "im-input", "text-input", 3, "ngClass"], ["class", "invalid-message", 4, "ngIf"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "lastName", "placeholder", "Enter your last Name", 1, "im-input", "text-input", 3, "ngClass"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "middleName", "placeholder", "Enter your middle Name", 1, "im-input", "text-input", 3, "ngClass"], [1, "row", "mt-2", "dotted-line"], ["type", "text", "formControlName", "personalEmailId", 1, "im-input", "text-input", 3, "ngClass"], [1, "label-cls", "dd-label"], ["formControlName", "phoneCode", 1, "form-control", "mt-2", 2, "width", "102%", "margin-left", "3px"], [3, "value", 4, "ngFor", "ngForOf"], ["type", "text", "formControlName", "mobileNumber", 1, "im-input", "text-input"], ["id", "startDate", "yearRange", "1900:2100", "appendTo", "body", "styleClass", "p-form-datepicker", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "dojDate", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YYYY", 1, "im-input-calendar", "mw-100", 3, "showIcon", "readonlyInput", "showButtonBar"], ["formControlName", "employementType", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", 3, "options"], ["optionLabel", "name", "optionValue", "code", "formControlName", "noticePeriod", "placeholder", "Select", 3, "options"], ["formControlName", "department", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", 3, "options"], ["formControlName", "reportingManager", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", 3, "options"], ["optionLabel", "name", "formControlName", "jobPosition", "optionValue", "code", "placeholder", "Select", 3, "options"], ["formControlName", "workShift", "optionLabel", "name", "optionValue", "id", "placeholder", "Select Shift", 3, "options"], [1, "detail-heading", "grid-head"], ["formGroupName", "gridEditorInputFields", 1, "row", "col-12", "mb-3", "grid-fields"], ["formControlName", "country", "optionLabel", "name", "optionValue", "code", "placeholder", "Select Country", 3, "options", "onChange"], ["class", "col mb-2", 4, "ngIf"], ["type", "text", "formControlName", "city", "placeholder", "Enter City", 1, "im-input"], [1, "col-12", "mb-3"], ["type", "button", 1, "btn", "btn-primary", "mr-2", 3, "disabled", "click"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], [1, "col-12"], ["styleClass", "vdFileUploadTable", 3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], ["type", "text", "formControlName", "compensation", "placeholder", "compensation", 1, "im-input", "text-input"], ["type", "text", "formControlName", "userName", "placeholder", "username", 1, "im-input", "text-input"], ["type", "text", "formControlName", "setPassword", "placeholder", "password", 1, "im-input", "text-input"], ["type", "text", "formControlName", "officialEmailId", "placeholder", "email", 1, "im-input", "text-input"], ["formControlName", "roles", "optionLabel", "name", "optionValue", "id", "placeholder", "Select Role", 3, "options"], [1, "editor-container", "grid-head"], [1, "customInputContainer"], ["formControlName", "welcomeEmail", 2, "height", "500px"], ["commonkendoeditor", ""], ["kendoEditorBoldButton", ""], ["kendoEditorItalicButton", ""], ["kendoEditorUnderlineButton", ""], ["kendoEditorStrikethroughButton", ""], ["kendoEditorSubscriptButton", ""], ["kendoEditorSuperscriptButton", ""], ["kendoEditorAlignLeftButton", ""], ["kendoEditorAlignCenterButton", ""], ["kendoEditorAlignRightButton", ""], ["kendoEditorAlignJustifyButton", ""], ["kendoEditorFormat", ""], ["kendoEditorFontSize", ""], ["kendoEditorFontFamily", ""], ["kendoEditorForeColor", ""], ["kendoEditorBackColor", "", "view", "gradient"], ["kendoEditorInsertUnorderedListButton", ""], ["kendoEditorInsertOrderedListButton", ""], ["kendoEditorIndentButton", ""], ["kendoEditorOutdentButton", ""], ["kendoEditorBlockquoteButton", ""], ["kendoEditorSelectAllButton", ""], ["kendoEditorUndoButton", ""], ["kendoEditorRedoButton", ""], ["kendoEditorCreateLinkButton", ""], ["kendoEditorUnlinkButton", ""], ["kendoEditorInsertFileButton", ""], ["kendoEditorViewSourceButton", ""], ["kendoEditorCleanFormattingButton", ""], ["kendoEditorAddColumnBeforeButton", ""], ["kendoEditorAddColumnAfterButton", ""], ["kendoEditorAddRowBeforeButton", ""], ["kendoEditorAddRowAfterButton", ""], ["kendoEditorDeleteColumnButton", ""], ["kendoEditorDeleteRowButton", ""], ["kendoEditorDeleteTableButton", ""], ["kendoEditorMergeCellsButton", ""], ["kendoEditorSplitCellButton", ""], ["kendoEditorPrintButton", ""], ["kendoEditorInsertImageButton", ""], ["title", "Upload\u2019s Image at cursor point", "text", "Upload Image", 3, "click"], [3, "editor"], ["commonkendoeditorupload", ""], ["formControlName", "welcomeKit", "optionLabel", "name", "placeholder", "Select", "optionValue", "id", 3, "options"], ["formControlName", "initiateBackgroundCheck", "optionLabel", "name", "placeholder", "Select", "optionValue", "id", 3, "options"], ["formControlName", "assetAllocation", "optionLabel", "name", "placeholder", "Select", "optionValue", "id", 3, "options"], ["formControlName", "otherInstructions", 2, "width", "100%"], ["type", "submit", 1, "btn", "btn-success", "save-btn", 3, "disabled", "ngClass"], [1, "invalid-message"], [3, "value"], [1, "col", "mb-2"], ["formControlName", "state", "optionLabel", "stateProvinceName", "optionValue", "stateProvinceCode", "placeholder", "Select State", 3, "options"], ["type", "text", "formControlName", "state", "placeholder", "State", 1, "im-input", "col-md"], [2, "text-align", "center"], [1, "buttons-holder"], ["type", "button", "title", "Edit", "pTooltip", "Edit", "pButton", "", "icon", "pi pi-pencil", 1, "p-button-text", "p-button-rounded", "mr-3", 3, "disabled", "click"], ["type", "button", "title", "Delete", "pTooltip", "Delete", "pButton", "", "icon", "pi pi-trash", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], ["colspan", "4"], [1, "visa-row-nodata"]], template: function LibAddNewEmployeeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h5", 0);
        i0.ɵɵtext(1, "Edit Record");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "form", 1, 2);
        i0.ɵɵlistener("ngSubmit", function LibAddNewEmployeeComponent_Template_form_ngSubmit_2_listener() { return ctx.saveEmployeeData(); });
        i0.ɵɵelementStart(4, "h6", 3);
        i0.ɵɵtext(5, "Employee Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵelementStart(8, "p", 6);
        i0.ɵɵtext(9, "Title");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(10, "p-dropdown", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 4);
        i0.ɵɵelementStart(12, "div", 5);
        i0.ɵɵelementStart(13, "p", 8);
        i0.ɵɵtext(14, "First Name");
        i0.ɵɵelementStart(15, "sup");
        i0.ɵɵtext(16, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(17, "input", 9);
        i0.ɵɵtemplate(18, LibAddNewEmployeeComponent_span_18_Template, 2, 0, "span", 10);
        i0.ɵɵtemplate(19, LibAddNewEmployeeComponent_span_19_Template, 2, 0, "span", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 5);
        i0.ɵɵelementStart(21, "p", 8);
        i0.ɵɵtext(22, "Last Name");
        i0.ɵɵelementStart(23, "sup");
        i0.ɵɵtext(24, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(25, "input", 11);
        i0.ɵɵtemplate(26, LibAddNewEmployeeComponent_span_26_Template, 2, 0, "span", 10);
        i0.ɵɵtemplate(27, LibAddNewEmployeeComponent_span_27_Template, 2, 0, "span", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 5);
        i0.ɵɵelementStart(29, "p", 8);
        i0.ɵɵtext(30, "Middle Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(31, "input", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 13);
        i0.ɵɵelementStart(33, "div", 5);
        i0.ɵɵelementStart(34, "p", 8);
        i0.ɵɵtext(35, "Personal Email");
        i0.ɵɵelementStart(36, "sup");
        i0.ɵɵtext(37, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(38, "input", 14);
        i0.ɵɵtemplate(39, LibAddNewEmployeeComponent_span_39_Template, 2, 0, "span", 10);
        i0.ɵɵtemplate(40, LibAddNewEmployeeComponent_span_40_Template, 2, 0, "span", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div", 5);
        i0.ɵɵelementStart(42, "p", 15);
        i0.ɵɵtext(43, "Phone Code");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "select", 16);
        i0.ɵɵtemplate(45, LibAddNewEmployeeComponent_option_45_Template, 2, 3, "option", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "div", 5);
        i0.ɵɵelementStart(47, "p", 8);
        i0.ɵɵtext(48, "Mobile Number");
        i0.ɵɵelementStart(49, "sup");
        i0.ɵɵtext(50, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(51, "input", 18);
        i0.ɵɵtemplate(52, LibAddNewEmployeeComponent_span_52_Template, 2, 0, "span", 10);
        i0.ɵɵtemplate(53, LibAddNewEmployeeComponent_span_53_Template, 2, 0, "span", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(54, "h6", 3);
        i0.ɵɵtext(55, "Job Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(56, "div", 4);
        i0.ɵɵelementStart(57, "div", 5);
        i0.ɵɵelementStart(58, "p", 6);
        i0.ɵɵtext(59, "Date of Joining");
        i0.ɵɵelementStart(60, "sup");
        i0.ɵɵtext(61, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(62, "p-calendar", 19);
        i0.ɵɵtemplate(63, LibAddNewEmployeeComponent_span_63_Template, 2, 0, "span", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(64, "div", 5);
        i0.ɵɵelementStart(65, "p", 6);
        i0.ɵɵtext(66, "Employement Type");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(67, "p-dropdown", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(68, "div", 5);
        i0.ɵɵelementStart(69, "p", 6);
        i0.ɵɵtext(70, "Notice Period");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(71, "p-dropdown", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(72, "div", 4);
        i0.ɵɵelementStart(73, "div", 5);
        i0.ɵɵelementStart(74, "p", 6);
        i0.ɵɵtext(75, "Department");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(76, "p-dropdown", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(77, "div", 5);
        i0.ɵɵelementStart(78, "p", 6);
        i0.ɵɵtext(79, "Reporting Manager");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(80, "p-dropdown", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(81, "div", 5);
        i0.ɵɵelementStart(82, "p", 6);
        i0.ɵɵtext(83, "Job Position");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(84, "p-dropdown", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(85, "div", 13);
        i0.ɵɵelementStart(86, "div", 5);
        i0.ɵɵelementStart(87, "p", 6);
        i0.ɵɵtext(88, "Work Shift");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(89, "p-dropdown", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(90, "div", 13);
        i0.ɵɵelementStart(91, "h6", 26);
        i0.ɵɵtext(92, "Work Location");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(93, "div", 27);
        i0.ɵɵelementStart(94, "div", 5);
        i0.ɵɵelementStart(95, "label", 6);
        i0.ɵɵtext(96, "Country");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(97, "p-dropdown", 28);
        i0.ɵɵlistener("onChange", function LibAddNewEmployeeComponent_Template_p_dropdown_onChange_97_listener($event) { return ctx.handleCountryChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(98, "div", 5);
        i0.ɵɵtemplate(99, LibAddNewEmployeeComponent_div_99_Template, 4, 4, "div", 29);
        i0.ɵɵtemplate(100, LibAddNewEmployeeComponent_div_100_Template, 4, 0, "div", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(101, "div", 5);
        i0.ɵɵelementStart(102, "label", 6);
        i0.ɵɵtext(103, "City");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(104, "input", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(105, "div", 31);
        i0.ɵɵelementStart(106, "button", 32);
        i0.ɵɵlistener("click", function LibAddNewEmployeeComponent_Template_button_click_106_listener() { return ctx.addGridEditorField(); });
        i0.ɵɵtext(107, " ADD ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(108, "button", 33);
        i0.ɵɵlistener("click", function LibAddNewEmployeeComponent_Template_button_click_108_listener() { return ctx.onReset(); });
        i0.ɵɵtext(109, " CANCEL ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(110, "div", 34);
        i0.ɵɵelementStart(111, "p-table", 35);
        i0.ɵɵtemplate(112, LibAddNewEmployeeComponent_ng_template_112_Template, 9, 0, "ng-template", 36);
        i0.ɵɵtemplate(113, LibAddNewEmployeeComponent_ng_template_113_Template, 11, 5, "ng-template", 37);
        i0.ɵɵtemplate(114, LibAddNewEmployeeComponent_ng_template_114_Template, 5, 0, "ng-template", 38);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(115, "h6", 3);
        i0.ɵɵtext(116, "Other Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(117, "div", 13);
        i0.ɵɵelementStart(118, "div", 5);
        i0.ɵɵelementStart(119, "p", 8);
        i0.ɵɵtext(120, "Compensation");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(121, "input", 39);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(122, "h6", 3);
        i0.ɵɵtext(123, "Onboarding Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(124, "div", 4);
        i0.ɵɵelementStart(125, "div", 5);
        i0.ɵɵelementStart(126, "p", 8);
        i0.ɵɵtext(127, "User Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(128, "input", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(129, "div", 5);
        i0.ɵɵelementStart(130, "p", 8);
        i0.ɵɵtext(131, "Set Password ");
        i0.ɵɵelementStart(132, "sup");
        i0.ɵɵtext(133, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(134, "input", 41);
        i0.ɵɵtemplate(135, LibAddNewEmployeeComponent_span_135_Template, 2, 0, "span", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(136, "div", 5);
        i0.ɵɵelementStart(137, "p", 8);
        i0.ɵɵtext(138, "Official EmailId");
        i0.ɵɵelementStart(139, "sup");
        i0.ɵɵtext(140, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(141, "input", 42);
        i0.ɵɵtemplate(142, LibAddNewEmployeeComponent_span_142_Template, 2, 0, "span", 10);
        i0.ɵɵtemplate(143, LibAddNewEmployeeComponent_span_143_Template, 2, 0, "span", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(144, "div", 13);
        i0.ɵɵelementStart(145, "div", 5);
        i0.ɵɵelementStart(146, "p", 6);
        i0.ɵɵtext(147, "Roles");
        i0.ɵɵelementStart(148, "sup");
        i0.ɵɵtext(149, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(150, "p-dropdown", 43);
        i0.ɵɵtemplate(151, LibAddNewEmployeeComponent_span_151_Template, 2, 0, "span", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(152, "div", 13);
        i0.ɵɵelementStart(153, "h6", 26);
        i0.ɵɵtext(154, "Welcome Email");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(155, "div", 44);
        i0.ɵɵelementStart(156, "span");
        i0.ɵɵtext(157, "Welcome email will be sent to the employee as soon as they login to their official email-ID");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(158, "div", 45);
        i0.ɵɵelementStart(159, "kendo-editor", 46, 47);
        i0.ɵɵelementStart(161, "kendo-toolbar");
        i0.ɵɵelementStart(162, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(163, "kendo-toolbar-button", 48);
        i0.ɵɵelement(164, "kendo-toolbar-button", 49);
        i0.ɵɵelement(165, "kendo-toolbar-button", 50);
        i0.ɵɵelement(166, "kendo-toolbar-button", 51);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(167, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(168, "kendo-toolbar-button", 52);
        i0.ɵɵelement(169, "kendo-toolbar-button", 53);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(170, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(171, "kendo-toolbar-button", 54);
        i0.ɵɵelement(172, "kendo-toolbar-button", 55);
        i0.ɵɵelement(173, "kendo-toolbar-button", 56);
        i0.ɵɵelement(174, "kendo-toolbar-button", 57);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(175, "kendo-toolbar-dropdownlist", 58);
        i0.ɵɵelement(176, "kendo-toolbar-dropdownlist", 59);
        i0.ɵɵelement(177, "kendo-toolbar-dropdownlist", 60);
        i0.ɵɵelement(178, "kendo-toolbar-colorpicker", 61);
        i0.ɵɵelement(179, "kendo-toolbar-colorpicker", 62);
        i0.ɵɵelementStart(180, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(181, "kendo-toolbar-button", 63);
        i0.ɵɵelement(182, "kendo-toolbar-button", 64);
        i0.ɵɵelement(183, "kendo-toolbar-button", 65);
        i0.ɵɵelement(184, "kendo-toolbar-button", 66);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(185, "kendo-toolbar-button", 67);
        i0.ɵɵelement(186, "kendo-toolbar-button", 68);
        i0.ɵɵelementStart(187, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(188, "kendo-toolbar-button", 69);
        i0.ɵɵelement(189, "kendo-toolbar-button", 70);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(190, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(191, "kendo-toolbar-button", 71);
        i0.ɵɵelement(192, "kendo-toolbar-button", 72);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(193, "kendo-toolbar-button", 73);
        i0.ɵɵelement(194, "kendo-toolbar-button", 74);
        i0.ɵɵelement(195, "kendo-toolbar-button", 75);
        i0.ɵɵelement(196, "kendo-editor-insert-table-button");
        i0.ɵɵelementStart(197, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(198, "kendo-toolbar-button", 76);
        i0.ɵɵelement(199, "kendo-toolbar-button", 77);
        i0.ɵɵelement(200, "kendo-toolbar-button", 78);
        i0.ɵɵelement(201, "kendo-toolbar-button", 79);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(202, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(203, "kendo-toolbar-button", 80);
        i0.ɵɵelement(204, "kendo-toolbar-button", 81);
        i0.ɵɵelement(205, "kendo-toolbar-button", 82);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(206, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(207, "kendo-toolbar-button", 83);
        i0.ɵɵelement(208, "kendo-toolbar-button", 84);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(209, "kendo-toolbar-button", 85);
        i0.ɵɵelementStart(210, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(211, "kendo-toolbar-button", 86);
        i0.ɵɵelementStart(212, "kendo-toolbar-button", 87);
        i0.ɵɵlistener("click", function LibAddNewEmployeeComponent_Template_kendo_toolbar_button_click_212_listener() { return ctx.commonkendoeditorimageuploaddialog(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(213, "app-upload-image-dialog", 88, 89);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(215, "h6", 3);
        i0.ɵɵtext(216, "Welcome kit");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(217, "div", 13);
        i0.ɵɵelementStart(218, "div", 5);
        i0.ɵɵelementStart(219, "p", 6);
        i0.ɵɵtext(220, "Select Welcome kit");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(221, "p-multiSelect", 90);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(222, "h6", 3);
        i0.ɵɵtext(223, "Other Internal Setup");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(224, "div", 4);
        i0.ɵɵelementStart(225, "div", 5);
        i0.ɵɵelementStart(226, "p", 6);
        i0.ɵɵtext(227, "Initiate Background Check");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(228, "p-multiSelect", 91);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(229, "div", 13);
        i0.ɵɵelementStart(230, "div", 5);
        i0.ɵɵelementStart(231, "p", 6);
        i0.ɵɵtext(232, "Asset Allocation");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(233, "p-multiSelect", 92);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(234, "div", 4);
        i0.ɵɵelementStart(235, "div", 5);
        i0.ɵɵelementStart(236, "p", 6);
        i0.ɵɵtext(237, "Other Instructions");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(238, "textarea", 93);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(239, "button", 94);
        i0.ɵɵtext(240, " Save ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r20 = i0.ɵɵreference(160);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.addNewEmployeeForm);
        i0.ɵɵadvance(8);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(59, _c1));
        i0.ɵɵproperty("options", ctx.titles);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(60, _c2, ctx.addNewEmployeeForm.get("firstName").touched && (ctx.addNewEmployeeForm.get("firstName").errors == null ? null : ctx.addNewEmployeeForm.get("firstName").errors.required)));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("firstName").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("firstName").errors == null ? null : ctx.addNewEmployeeForm.get("firstName").errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("firstName").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("firstName").errors == null ? null : ctx.addNewEmployeeForm.get("firstName").errors.pattern));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(62, _c2, ctx.addNewEmployeeForm.get("lastName").touched && (ctx.addNewEmployeeForm.get("lastName").errors == null ? null : ctx.addNewEmployeeForm.get("lastName").errors.required)));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("lastName").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("lastName").errors == null ? null : ctx.addNewEmployeeForm.get("lastName").errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("lastName").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("lastName").errors == null ? null : ctx.addNewEmployeeForm.get("lastName").errors.pattern));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(64, _c2, ctx.addNewEmployeeForm.get("middleName").touched && (ctx.addNewEmployeeForm.get("middleName").errors == null ? null : ctx.addNewEmployeeForm.get("middleName").errors.required)));
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(66, _c2, (ctx.addNewEmployeeForm.get("personalEmailId").touched || ctx.submitted) && ((ctx.addNewEmployeeForm.get("personalEmailId").errors == null ? null : ctx.addNewEmployeeForm.get("personalEmailId").errors.required) || (ctx.addNewEmployeeForm.get("personalEmailId").errors == null ? null : ctx.addNewEmployeeForm.get("personalEmailId").errors.email))));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("personalEmailId").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("personalEmailId").errors == null ? null : ctx.addNewEmployeeForm.get("personalEmailId").errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("personalEmailId").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("personalEmailId").errors == null ? null : ctx.addNewEmployeeForm.get("personalEmailId").errors.email));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.DataArr);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("mobileNumber").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("mobileNumber").errors == null ? null : ctx.addNewEmployeeForm.get("mobileNumber").errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("mobileNumber").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("mobileNumber").errors == null ? null : ctx.addNewEmployeeForm.get("mobileNumber").errors.pattern));
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("showIcon", true)("readonlyInput", true)("showButtonBar", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("dojDate").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("dojDate").errors == null ? null : ctx.addNewEmployeeForm.get("dojDate").errors.required));
        i0.ɵɵadvance(4);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(68, _c1));
        i0.ɵɵproperty("options", ctx.employementTypes);
        i0.ɵɵadvance(4);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(69, _c1));
        i0.ɵɵproperty("options", ctx.noticePeriod);
        i0.ɵɵadvance(5);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(70, _c1));
        i0.ɵɵproperty("options", ctx.departments);
        i0.ɵɵadvance(4);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(71, _c1));
        i0.ɵɵproperty("options", ctx.reportingManagers);
        i0.ɵɵadvance(4);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(72, _c1));
        i0.ɵɵproperty("options", ctx.positions);
        i0.ɵɵadvance(5);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(73, _c1));
        i0.ɵɵproperty("options", ctx.shifts);
        i0.ɵɵadvance(8);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(74, _c1));
        i0.ɵɵproperty("options", ctx.countries);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.listStates == null ? null : ctx.listStates.length) > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.listStates == null ? null : ctx.listStates.length) == 0);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", ctx.disableAddButton);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("value", ctx.gridEditorFields.controls);
        i0.ɵɵadvance(24);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("setPassword").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("setPassword").errors == null ? null : ctx.addNewEmployeeForm.get("setPassword").errors.required));
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("officialEmailId").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("officialEmailId").errors == null ? null : ctx.addNewEmployeeForm.get("officialEmailId").errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("officialEmailId").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("officialEmailId").errors == null ? null : ctx.addNewEmployeeForm.get("officialEmailId").errors.email));
        i0.ɵɵadvance(7);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(75, _c1));
        i0.ɵɵproperty("options", ctx.roles);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.addNewEmployeeForm.get("roles").touched || ctx.submitted) && (ctx.addNewEmployeeForm.get("roles").errors == null ? null : ctx.addNewEmployeeForm.get("roles").errors.required));
        i0.ɵɵadvance(62);
        i0.ɵɵproperty("editor", _r20);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("options", ctx.welcomeKitList);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("options", ctx.backgroundCheckList);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("options", ctx.assetAllocationList);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", ctx.addNewEmployeeForm.invalid)("ngClass", i0.ɵɵpureFunction1(76, _c3, ctx.addNewEmployeeForm.invalid));
    } }, directives: [i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i7.Dropdown, i1$1.NgControlStatus, i1$1.FormControlName, i1$1.DefaultValueAccessor, i1$1.PatternValidator, i8.NgClass, i8.NgIf, i1$1.SelectControlValueAccessor, i8.NgForOf, i9.Calendar, i1$1.FormGroupName, i10.Table, i11.PrimeTemplate, i12.EditorComponent, i13.ToolBarComponent, i13.ToolBarButtonGroupComponent, i13.ToolBarButtonComponent, i12.EditorBoldButtonDirective, i12.EditorItalicButtonDirective, i12.EditorUnderlineButtonDirective, i12.EditorStrikethroughButtonDirective, i12.EditorSubscriptButtonDirective, i12.EditorSuperscriptButtonDirective, i12.EditorAlignLeftButtonDirective, i12.EditorAlignCenterButtonDirective, i12.EditorAlignRightButtonDirective, i12.EditorAlignJustifyButtonDirective, i12.EditorFormatComponent, i12.EditorFontSizeComponent, i12.EditorFontFamilyComponent, i12.EditorColorPickerComponent, i12.EditorForeColorDirective, i12.EditorBackColorDirective, i12.EditorInsertUnorderedListButtonDirective, i12.EditorInsertOrderedListButtonDirective, i12.EditorIndentButtonDirective, i12.EditorOutdentButtonDirective, i12.EditorBlockquoteDirective, i12.EditorSelectAllButtonDirective, i12.EditorUndoButtonDirective, i12.EditorRedoButtonDirective, i12.EditorCreateLinkButtonDirective, i12.EditorUnlinkButtonDirective, i12.EditorInsertFileButtonDirective, i12.EditorViewSourceButtonDirective, i12.EditorCleanFormattingButtonDirective, i12.EditorInsertTableButtonComponent, i12.EditorAddColumnBeforeButtonDirective, i12.EditorAddColumnAfterButtonDirective, i12.EditorAddRowBeforeButtonDirective, i12.EditorAddRowAfterButtonDirective, i12.EditorDeleteColumnButtonDirective, i12.EditorDeleteRowButtonDirective, i12.EditorDeleteTableButtonDirective, i12.EditorMergeCellsButtonDirective, i12.EditorSplitCellButtonDirective, i12.EditorPrintDirective, i12.EditorInsertImageButtonDirective, i14.UploadImageDialogComponent, i15.MultiSelect, i1$1.NgSelectOption, i1$1.ɵangular_packages_forms_forms_z, i16.Tooltip, i17.ButtonDirective], styles: ["sup[_ngcontent-%COMP%]{color:#c54545}.dotted-line[_ngcontent-%COMP%]{border-bottom:1px dotted #000;margin-bottom:10px;padding-bottom:10px;position:relative;right:14px}.detail-heading[_ngcontent-%COMP%]{font-weight:600}.text-input[_ngcontent-%COMP%]{margin-left:1px}.editor-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:10px}.grid-head[_ngcontent-%COMP%]{margin-left:14px}.grid-fields[_ngcontent-%COMP%]{margin-left:-16px}.customInputContainer[_ngcontent-%COMP%]{width:100%}.row-margin[_ngcontent-%COMP%]{margin-bottom:10px;padding-bottom:10px;position:relative;right:14px}.edit-emp-heading[_ngcontent-%COMP%]{font-weight:600;margin-bottom:18px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibAddNewEmployeeComponent, [{
        type: Component,
        args: [{
                selector: 'lib-add-new-employee',
                templateUrl: './lib-add-new-employee.component.html',
                styleUrls: ['./lib-add-new-employee.component.scss'],
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: LibAddNewEmployeeService }, { type: i3.ReferenceLibraryService }, { type: i0.ChangeDetectorRef }, { type: i4.CacheCountryListService }, { type: i5.ToastrService }, { type: i6.Store }]; }, { formSaved: [{
            type: Output
        }], employeeDetails: [{
            type: Input
        }], commonkendoeditorupload: [{
            type: ViewChild,
            args: ["commonkendoeditorupload"]
        }] }); })();

class LibAddNewEmployeeModule {
}
LibAddNewEmployeeModule.ɵfac = function LibAddNewEmployeeModule_Factory(t) { return new (t || LibAddNewEmployeeModule)(); };
LibAddNewEmployeeModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibAddNewEmployeeModule });
LibAddNewEmployeeModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            ReactiveFormsModule,
            PrimengLibraryModule,
            EditorModule,
            EditorLibraryModule,
            FroalaEditorModule,
            FroalaViewModule
            // FroalaEditorModule.forRoot(),
            // FroalaViewModule.forRoot(),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibAddNewEmployeeModule, { declarations: [LibAddNewEmployeeComponent], imports: [ReactiveFormsModule,
        PrimengLibraryModule,
        EditorModule,
        EditorLibraryModule,
        FroalaEditorModule,
        FroalaViewModule
        // FroalaEditorModule.forRoot(),
        // FroalaViewModule.forRoot(),
    ], exports: [LibAddNewEmployeeComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibAddNewEmployeeModule, [{
        type: NgModule,
        args: [{
                declarations: [LibAddNewEmployeeComponent],
                imports: [
                    ReactiveFormsModule,
                    PrimengLibraryModule,
                    EditorModule,
                    EditorLibraryModule,
                    FroalaEditorModule,
                    FroalaViewModule
                    // FroalaEditorModule.forRoot(),
                    // FroalaViewModule.forRoot(),
                ],
                exports: [LibAddNewEmployeeComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-add-new-employee
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibAddNewEmployeeComponent, LibAddNewEmployeeModule, LibAddNewEmployeeService };
//# sourceMappingURL=lib-add-new-employee.js.map
